import {
    ListItem,
    Typography, List, Divider, Grid,
} from "@mui/material";
import React, {useMemo} from "react";
import {useCargoList} from "~/apps/packages/warehouse-closure/hooks";
import {Cargo} from "~/apps/packages/warehouse-closure/queries";
import {SelectableCard} from "~/apps/core/ui/SelectableCard";
import {TypographyWithLabel} from "~/apps/core/ui/TypographyWithLabel";
import {findScrollableNode, useBottomScrollListener} from "~/lib/useBottomScrollListener";
import moment from "moment";
import {LoadingBox} from "~/apps/core/ui/LoadingBox";
import {Tag} from "~/apps/core/ui/Tag";
import {humanizeCargoTag} from "~/apps/packages/warehouse-closure/utils";
import {BorderedBox} from "~/apps/core/ui/BorderedBox";
import {Box} from "@mui/system";


export type CargoListProps = {
    query?: string
    cargoType?: string
    itemClick?: (cargo: Cargo) => void
    selectedIds?: Cargo["id"][]
    excludeCodes?: Cargo["code"][]
}


export const CargoList = (props: CargoListProps) => {
    const {query, cargoType, itemClick, selectedIds, excludeCodes} = props;

    const {data, loading, fetchMore, canFetchMore} = useCargoList({
        query: query,
        type: cargoType,
        excludeCodes: excludeCodes,
    });

    const setScrollNode = useBottomScrollListener(() => {
        fetchMore();
    }, 50, 100, false);

    const items = useMemo(() => {
        const _selectedIds = new Set(selectedIds);

        return data?.map(item => ({
            ...item,
            selected: _selectedIds.has(item.id)
        }));
    }, [data, selectedIds, excludeCodes]);

    const handlerItemClick = (item) => () => {
        itemClick && itemClick(item)
    }

    const handleRef = (node) => {
        setScrollNode(findScrollableNode(node));
    }

    return (
        <LoadingBox loading={loading} empty={items?.length == 0} placeholder={canFetchMore}>
            {items?.length > 0 && (
                <List ref={handleRef}>
                    {items?.map((item) => (
                        <ListItem key={item.id}>
                            <SelectableCard
                                selected={item.selected}
                                onClick={handlerItemClick(item)}
                                title={(
                                    <>
                                        <Box paddingBottom="8px" display="flex">
                                            {item.container?.number || item.label || "Груз без маркировки"}

                                            {item.container?.type && (
                                                <BorderedBox marginLeft="8px" variant="cardText">
                                                    {item.container.type}
                                                </BorderedBox>
                                            )}
                                        </Box>
                                        <Typography variant="tagsText" display="block" component="div" color="secondary">
                                            {item.description}
                                        </Typography>
                                    </>
                                )}
                            >
                                <Grid container spacing="8px">
                                    {Object.entries(item.tags || {}).filter(([key, value]) => value).map(([key, value]) => (
                                        <Grid item key={key}>
                                            <Tag>
                                                {humanizeCargoTag(key as any)}
                                            </Tag>
                                        </Grid>
                                    ))}
                                </Grid>

                                <Divider/>
                                <TypographyWithLabel label={item.arrival?.document?.type} noWrap={false}>
                                    {item.arrival?.document?.number} от {moment(item.arrival?.document?.date).format("DD MMM YYYY")}
                                </TypographyWithLabel>
                            </SelectableCard>
                        </ListItem>
                    ))}
                </List>
            )}
        </LoadingBox>
    );
}